import { bscTestnet, bsc } from "viem/chains";
import { ENV_SECRETS } from './env.secrets';

export const environment = {
    production: false,
    IS_STAGING: true,
    SUPPORTED_CHAINS: [bscTestnet],
    ENCRYPT_LOCAL_STORAGE: false,
    LANGUAGES_FILE_PATH: 'assets/i18n/',
    LOCAL_STORAGE_SECRET: ENV_SECRETS.LOCAL_STORAGE_SECRET,
    WALLET_CONNECT_PROJECT_ID: ENV_SECRETS.WALLET_CONNECT_PROJECT_ID,
    API_BASE_URL: 'https://stagingweb3api.alphaomegacoin.com/',
    dev_url: '  https://stagingweb3.alphaomegacoin.com/',
    COINBIT_API_BASE_URL: 'https://api.coinsbit.io/api/v1',
    NETWORK_ID: ['0x61'],
    COUNTRY_CODE_BASE_URL: 'https://ipapi.co/json/',
    BSC_TRANSACTION_HASH_BASEURL: 'https://testnet.bscscan.com/tx/',
    TRON_TRANSACTION_HASH_BASEURL: 'https://tronscan.org/#/transaction/',
    ETH_TRANSACTION_HASH_BASEURL: 'https://etherscan.io/tx/',
    DISTRIBUTION_DAPP_URL: 'https://stagingtokendistribution.com/',
    NETWORK_NAME: 'BSC-TESTNET',
    NETWORK_SYMBOL: 'bsc',
    NETWORK_CURRENCY: 'BNB',
    TRANSACTION_URI: 'https://testnet.bscscan.com/tx/',
    TEST_CHAIN: 'bsc',
    RPC_URL: ENV_SECRETS.RPC_URL,
    AOC_TOKEN: "0x7dD88BF0bcf02C77F80F575A1C202492865137DB",
    CROWD_SALE: "0x7de3630d8C04Fc425a07CAe81080923d60cDA2d8",
    USDT_CONTRACT: "0x52D896ff34D797efe460dB898DDa1edE0bfe4a9b",
    CROWD_SALE_V2: "0x11D758014018Db2C3d376eB47c8e7A5bDCd5374b",
    CHAIN_ID: 97,
    ALLOWED_NETWORKS: [
        '0x61', // BSC Testnet
        '0x38',
        '0x5', // ETH Goerli Testnet
        '0x13881', // Polygon Mumbai Testnet
        '0xa869', // Avalanche Fuji Testnet
        '0xfa2', // Fantom Testnet
        '0x152', // Cronos Testnet
        '0x507', // Moonbase Alpha Testnet
        '0x1', // ETH Mainnet
        '0x38', // BSC Mainnet
        '0x89', // Polygon Mainnet
        '0xa86a', // Avalanche C-Chain Mainnet
        '0xfa', // Fantom Opera Mainnet
        '0x19', // Cronos Mainnet
        '0x504', // Moonbeam Mainnet
    ],
    EN_WHATSAPP_LINK: "https://whatsapp.com/channel/0029Vb5qc5JGk1FpNl8qy30g",
    FR_WHATSAPP_LINK: "https://whatsapp.com/channel/0029VaGARw98PgsOIqrx9Q3J",
    PLAY_STORE_LINK: 'https://rtyxi.test-app.link/ifoMSAJzDSb/?ref=',
    DIRECT_APP_LINK_PLAY_STORE: 'https://play.google.com/store/apps/details?id=com.alpha_omega_coin',
    CHATBOT_KEY: ENV_SECRETS.CHATBOT_KEY,
    AOC_LANDING_PAGE_BASE_URL:"https://stagingweb3admin2api.alphaomegacoin.com/api/",
    LOCKUP_DAPP_URL: "http://54.236.53.42/aoc-token-locker/",
    // Request-log device tracking: the device register call and the x-device-* headers.
    // Off until the backend register route is live in this environment.
    DEVICE_TRACKING_ENABLED: true

};
